(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-horizontal-facet-filter-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const horizontalFacetBar = document.querySelector('.horizontal-facet-filter-bar');
    const productGrid = document.querySelector('.collection-products');
    const collection_list_intro_wrap = document.querySelector('.collection_list_intro_wrap');
    
    let ajaxController = null;
    // UTILITY: Refresh active chips
    function renderActiveChips(html) {
      const tempDom = new DOMParser().parseFromString(html, 'text/html');
      const newFilterBar = tempDom.querySelector('.horizontal-facet-filter-bar');
      if (newFilterBar) {
        horizontalFacetBar.innerHTML = newFilterBar.innerHTML;
      }
    }
    

    // AJAX filter handling (checkbox & dropdown remove)
    document.addEventListener('change', function (e) {
      const form = e.target.closest('.horizontal-facet-filter-bar form');
      if (!form) return;

      e.preventDefault();
      pullProducts();
    });

    // REMOVE individual chip (bottom or dropdown)
    document.addEventListener('click', function (e) {
      const removeBtn = e.target.closest('.remove-filter');
      if (!removeBtn) return;

      const value = e.target.dataset.filter;

      const form = e.target.closest('.horizontal-facet-filter-bar form');
      if (!form) return;

      // Uncheck checkbox(s) matching value
      form.querySelectorAll(`input[value="${value}"]`).forEach((cb) => (cb.checked = false));

      // Animate chip removal
      const chip = removeBtn.closest('.active-filter-chip');
      if (chip) {
        chip.style.transition = 'all 0.3s ease';
        chip.style.opacity = 0;
        chip.style.transform = 'scale(0.9)';
        setTimeout(() => chip.remove(), 300);
      }

      
      const activeFilterChip = document.querySelectorAll(`.active-filter-chip`);
      const clearAllBtn = document.querySelector('.clear-all-filters');
      if (activeFilterChip.length === 1 && clearAllBtn) {
        clearAllBtn.remove();
      }

      pullProducts();
    });

    // CLEAR ALL FILTERS
    document.addEventListener('click', function (e) {
      const clearAllBtn = e.target.closest('.clear-all-filters');
      if (!clearAllBtn) return;

      const form = clearAllBtn.closest('.horizontal-facet-filter-bar form');
      if (!form) return;

      form.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach((cb) => (cb.checked = false));
      pullProducts();
    });

    function pullProducts() {
      if (ajaxController) {
        ajaxController.abort();
      }
     
      const filterForm = document.querySelector('.horizontal-facet-filter-bar form');
      const url = new URL(filterForm.action);
      const formData = new FormData(filterForm);
      filterForm.classList.add('loading');
      
      var collection;
      // Clear existing params
      url.search = '';
      formData.forEach((value, key) => {
        
        url.pathname = window.location.pathname;
        
        if (key.includes('collections')) {
          let selectedCollection = document.querySelector('input[name="' + key + '"][value="' + value + '"]');
          collection = selectedCollection.dataset.filterName;
          
          if (collection == 'all-products') {
            collection = 'all';        
          }
          // url.pathname = `/collections/${collection}`;
        }
        url.searchParams.append(key, value);
      });


      ajaxController = new AbortController();
      if(collection) {
        url.pathname = `/collections/${collection}`;
      }
      fetch(url.toString(), { signal: ajaxController.signal })
        .then((res) => res.text())
        .then((html) => {
          gsap.fromTo(productGrid, { opacity: 1 }, { opacity: 0, duration: 1, ease: 'power1.out' });
          const tempDom = new DOMParser().parseFromString(html, 'text/html');
          const newGrid = tempDom.querySelector('.collection-products');
          renderActiveChips(html);
          if (newGrid && productGrid) productGrid.innerHTML = newGrid.innerHTML;

          collection_list_intro_wrap.innerHTML = tempDom.querySelector('.collection_list_intro_wrap').innerHTML;
          if(collection && url.pathname != `/collections/${collection}`) {
          url.pathname = `/collections/${collection}`;
          }
          // URL cleanup
          const cleanUrl =
            url.origin +
            url.pathname +
            '?' +
            [...url.searchParams]
              .filter(([_, v]) => v !== '')
              .map(([k, v]) => `${k}=${v}`)
              .join('&');
          window.history.pushState({}, '', cleanUrl);
          gsap.fromTo(productGrid, { opacity: 0 }, { opacity: 1, duration: 1, ease: 'power1.out' });
          gsap.to(window, {
            duration: 1.4,
            scrollTo: { y: productGrid, offsetY: 80 },
            ease: 'power3.inOut',
          });
          ScrollTrigger.refresh(true); // forces re-measure

          filterForm.classList.remove('loading');
        });
    }

    // pullProducts()
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {

  // =========================
  // Helper: play/pause by active slide
  // =========================
  function pauseAllSwiperVideos(swiperEl) {
    swiperEl.querySelectorAll('.lazy-video').forEach(v => v.pause());
  }

  function playActiveSlideVideo(swiper) {
    const activeSlide = swiper.slides[swiper.activeIndex];
    if (!activeSlide) return;

    const video = activeSlide.querySelector('.lazy-video');
    if (!video) return;

    // Lazy-load on first play
    if (video.preload !== 'auto') {
      video.preload = 'auto';
      video.load();
    }
    video.play().catch(() => {});
  }

  // =========================
  // Swiper
  // =========================
  const swiperEl = document.querySelector('.productSwiper');

  const swiper = new Swiper(swiperEl, {
    loop: true,
    speed: 600,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      0:   { slidesPerView: 1.1 },
      768: { slidesPerView: 1, effect: 'fade', fadeEffect: { crossFade: true } },
    },

    // Play active slide video after every transition
    on: {
      slideChangeTransitionEnd() {
        pauseAllSwiperVideos(swiperEl);
        playActiveSlideVideo(this);
      },
      // Also handle the very first slide on init
      afterInit() {
        playActiveSlideVideo(this);
      },
    },
  });

  // =========================
  // IntersectionObserver — only for the SWIPER CONTAINER
  // pause everything when the whole slider scrolls out of view,
  // resume active slide when it scrolls back in
  // =========================
  const containerObserver = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        playActiveSlideVideo(swiper);
      } else {
        pauseAllSwiperVideos(swiperEl);
      }
    },
    { threshold: 0.5 }
  );

  containerObserver.observe(swiperEl);
});

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.quantity-btn');
    if (!btn) return;

    const container = btn.closest('.item-quantity');
    if (!container) return;

    const input = container.querySelector('.quantity-input');
    if (!input) return;

    const min = parseInt(input.getAttribute('min')) || 1;
    let value = parseInt(input.value) || min;

    if (btn.classList.contains('quantity-plus')) {
      value++;
    }

    if (btn.classList.contains('quantity-minus')) {
      value = Math.max(min, value - 1);
    }

    input.value = value;

    // Optional: trigger change event (Shopify themes rely on this)
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  // document.addEventListener('DOMContentLoaded', function () {
  //   const thumbnailItems = document.querySelectorAll('.thumbnail-item');
  //   const mainImage = document.querySelector('.main-product-image');

  //   if (thumbnailItems.length > 0 && mainImage) {
  //     thumbnailItems.forEach(function (item) {
  //       item.addEventListener('click', function () {
  //         const imageUrl = this.getAttribute('data-image');

  //         // Update main image
  //         mainImage.src = imageUrl;

  //         // Update active state
  //         document.querySelectorAll('.thumbnail-item').forEach(function (thumb) {
  //           thumb.classList.remove('active');
  //         });
  //         this.classList.add('active');
  //       });
  //     });
  //   }
  // });

  } catch(e) { console.error(e); }
})();
})();
